import { render, staticRenderFns } from "./UploadImagemCampanhaDialog.vue?vue&type=template&id=678af808&"
import script from "./UploadImagemCampanhaDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImagemCampanhaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports